import { useTranslation } from "react-i18next";
import PageContent from "../components/pageContent";

const NotImplementedPage = () => {

  const { t } = useTranslation(undefined);
  
  return (
    <PageContent>
      <>
        <h2
          style={{
            textAlign: "center",
            padding: "50px",
            fontWeight: "bold",
            textShadow: "2px 1px #ffd0d0",
          }}
        >
          {t('MissingPermissionToShowRequiredPage')}
        </h2>
      </>
    </PageContent>
  );
};

export default NotImplementedPage;
